import { Icon } from "@rmwc/icon"
import "@rmwc/icon/styles"

const IconComponent = <Icon icon="info_outline" />

export const InfoIcon = IconComponent
